import { barGraphLabelMarginLeft, maxTickWidth } from '../Config';
import { getTickSizeCalculator } from './ticks';

type YAxisDimensions = {
    width: number; // The width of the Y-axis area
};

/**
 * Function to calculate and manage the Y-axis dimensions for horizontal bar charts
 *
 * @param isHorizontal Whether the chart is in horizontal layout
 * @param categories The categories displayed on the Y-axis
 * @param containerWidth The width of the container in which the chart is rendered
 * @param labelVisible Whether the Y-axis label is visible
 * @returns The calculated Y-axis dimensions
 */
export function getYAxisDimensions(
    isHorizontal: boolean,
    categories: string[],
    containerWidth: number,
    labelVisible?: boolean
): YAxisDimensions {
    if (!isHorizontal || categories.length === 0) {
        return {
            width: 60
        };
    }

    // 25% of the container width, or maximum tick width, whichever is larger
    const maxAllowedWidth = Math.max(maxTickWidth, Math.floor(containerWidth * 0.25));

    const tickSizeCalculator = getTickSizeCalculator();

    // Get the longest category text length
    const longestCategoryWidth = Math.max(0, ...categories.map(tickSizeCalculator));

    const tickLineLength = 10;
    const labelMargin = labelVisible ? barGraphLabelMarginLeft : 10;

    // Calculate the optimal width based on the longest text or use minimum width
    const optimalWidth = Math.min(maxAllowedWidth, longestCategoryWidth + tickLineLength + labelMargin);

    return {
        width: optimalWidth
    };
}
